import BaseModel from "../core/BaseModel";
export default class SraModel extends BaseModel {
  constructor() {
    super(
      {
        name: "sra",
        tableName: "sra",
        label: "Danh sách công việc",
        display_key: "name",
      },
      {
        stt: { 
          name: "stt", 
          label: "STT",
          class: 'center', 
          computed: (data, index) => {
            data.stt = index + 1;
          }
        },
        id: { 
          name: 'id', 
          type: "Uuid", 
          label: 'ID', 
          primaryKey: true,
          display: false
        },
        risk_level: {
          name: "risk_level",
          label: "Mức độ rủi ro",
          type: "Selection",
          custom: 'SelectionText',
          class: 'center',
          options: [
            { value: "LOW", label: "Thấp" },
            { value: "MEDIUM", label: "Trung bình" },
            { value: "HIGH", label: "Cao" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        code: {
          name: "code",
          type: "CustomUrl",
          label: "Mã công việc",
          style : "width:100px;",
          filter: { type: "input", match: "contains" },
        },
        name: {
          name: "name",
          type: "String",
          label: "Tên gói công việc",
          minWidth : 10,
          filter: { type: "input", match: "contains" },
        },
        contractor_name: {
          name: "contractor_name",
          type: "String",
          label: "Nhà thầu",
          minWidth : 10,
          filter: { type: "input", match: "contains" },
        },
        areas_html: {
          name: "areas_html",
          type: "CustomUrl",
          label: "Khu vực làm việc",
          minWidth : 10,
          filter: { type: "input", match: "contains" },
        },
        // factory: {
        //   name: "factory",
        //   label: "Nhà máy",
        //   type: "MultiSelect",
        //   filter: {
        //     type: "SelectScroll",
        //     optionLabel: "name",
        //     optionKey: "id",
        //     match: "equals",
        //   },
        //   minWidth : 10,
        // },
        factory_name: {
          name: "factory_name",
          type: "String",
          label: "Nhà máy",
          minWidth : 10,
          filter: { type: "input", match: "contains" },
        },
        status: {
          name: "status",
          label: "Trạng thái phê duyệt",
          type: "Selection",
          class: "center",
          options: [
            { value: "NEW", label: "Mới" },
            { value: "APPROVED_LV1", label: "Đã duyệt cấp 1" },
            { value: "APPROVED", label: "Đã duyệt" },
            { value: "REJECTED", label: "Bị từ chối" },
            { value: "CLOSE", label: "Đã đóng" },
            { value: "CANCEL", label: "Đã hủy" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        status_work: {
          name: "status_work",
          label: "Trạng thái công việc",
          type: "Selection",
          class: "center",
          options: [
            { value: "waiting", label: "Chờ thực hiện" },
            { value: "processing", label: "Đang thực hiện" },
            { value: "done", label: "Hoàn thành" },
            { value: "pending", label: "Tạm dừng" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        created_name: {
          name: "created_name",
          type: "String",
          label: "Người tạo",
          minWidth : 10,
          filter: { type: "input", match: "contains" },
        },
        sra_evaluate_txt:{
          name: 'sra_evaluate_txt',
          type: 'Text',
          label: 'Đánh giá',
          minWidth : 10,
          computed: (data) => {
            data.sra_evaluate_txt = '';
          },
        },
        awt_html: {
          name: "awt_html",
          type: "CustomUrl",
          label: "Giấy phép làm việc ATW",
          // style : "width:100px;",
          filter: { type: "input", match: "contains" },
          display: false,
        },
        count_daily_atw_html: {
          name: "count_daily_atw_html",
          type: "CustomUrl",
          label: "Số lượng giấy phép làm việc",
          minWidth : 10,
          class: "center"
        },
        last_daily_atw_html: {
          name: "last_daily_atw_html",
          type: "CustomUrl",
          // label: "Giấy phép ngày (Daily ATW)",
          label: "Giấy phép làm việc",
          // style : "width:100px;",
        },
        time_sra: {
          name: "time_sra",
          type: "String",
          label: "Thời gian SRA",
          // width: 6,
          filter: { type: 'DateRange', match: 'contains'},
        },
        text_supervisor: {
          name: "text_supervisor",
          type: "String",
          label: "Giám sát",
          minWidth : 10,
          filter: { type: "input", match: "contains" },
        },
        hscd : {
          name: 'hscd', 
          type: "CustomUrl", 
          label: 'Hồ sơ chờ duyệt',
          width: 6,
          class: 'center',
          computed: (data) => {
            data.hscd = '';
          }
        },
        hsdn : {
          name: 'dsdn', 
          type: "CustomUrl", 
          label: 'HSDN',
          width: 5,
          class: 'center',
          computed: (data) => {
            data.hsdn = '';
          }
        },
        nhansu : {
          name: 'nhansu', 
          type: "CustomUrl", 
          label: 'Nhân sự',
          width: 5,
          class: 'center',
          computed: (data) => {
            data.nhansu = '';
          }
        },
        vattu : {
          name: 'vattu', 
          type: "CustomUrl", 
          label: 'Vật tư',
          width: 5,
          class: 'center',
          computed: (data) => {
            data.vattu = '';
          }
        },
        thietbi : {
          name: 'thietbi', 
          type: "CustomUrl", 
          label: 'Thiết bị',
          width: 5,
          class: 'center',
          computed: (data) => {
            data.thietbi = '';
          }
        },
        // active: {
        //   name: "active",
        //   type: "Boolean",
        //   label: "Hiển thị",
        //   class: "center"
        // },

        // updated_by: {
        //   name: "updated_by",
        //   type: "String",
        //   label: "Người cập nhật"
        // },

        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối"
        },
      }
    );
  }
}
